import { jsx } from 'panel';
import { delayedAttrRemove } from 'panel/build/component-utils/hook-helpers';
import { ModalEl } from 'common/components/modal';
import { CustomAlertEl } from 'common/widgets/alerts/custom-alert';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { InputEl } from 'common/components/input';
import { LastUpdatedEl } from 'common/components/last-updated';
import { ControlBarEl } from 'common/widgets/control-bar';
import { SharingStatusButtonEl } from 'common/widgets/sharing/status-button';
import { UserIconEl } from 'common/widgets/user-icon';
import { getPublicDashboardTextHighlight } from 'common/templates/public-dashboards/mixins';
import { BoardsSaveButtonEl } from 'common/widgets/query-report-header/boards-save-menu';
import { SvgIconEl } from 'common/components/svg-icon';
import { TooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
import { HeaderAction, SaveModes } from './types';
export function AlertModal(_ref) {
  let {
    cmp
  } = _ref;
  const displayContext = cmp.attr("display-context");
  const isReportValid = ["insights", "funnels"].includes(displayContext);

  if (cmp.state.isCreateAlertModalOpen && isReportValid) {
    const resultsKeysAndValues = cmp.attr("results-keys-and-values");
    const isPercentageThreshold = (resultsKeysAndValues === null || resultsKeysAndValues === void 0 ? void 0 : resultsKeysAndValues.length) && resultsKeysAndValues[resultsKeysAndValues.length - 1].isPercentage === true;
    return jsx(ModalEl, {
      sel: '.alert-modal',
      hook: {
        remove: delayedAttrRemove("open", false)
      },
      attrs: {
        open: true,
        closeable: true,
        'grow-to-content': true,
        'hide-close-button': true
      },
      on: {
        change: ev => ev.detail.state === "closed" && cmp.helpers.closeCustomAlertModal()
      }
    }, jsx(CustomAlertEl, {
      attrs: {
        'bookmark-id': cmp.attr("selected-bookmark-id"),
        'enable-condition-types': cmp.attr("enable-custom-alert-condition-types"),
        'is-editing-mode': false,
        'is-percentage-threshold': isPercentageThreshold,
        'project-id': cmp.attr("project-id"),
        'report-type': displayContext,
        'results-keys-and-values': cmp.attr("results-keys-and-values"),
        'time-unit': cmp.attr("custom-alert-time-unit")
      },
      on: {
        cancel: cmp.helpers.closeCustomAlertModal,
        create: cmp.helpers.handleCustomAlertCreated,
        error: cmp.helpers.handleCustomAlertError
      }
    }));
  }

  return null;
}

const BoardsTitle = (cmp, dashboard) => {
  const canEdit = cmp.canEditReportName();
  return jsx("div", {
    sel: '.mp-query-report-header-boards-title'
  }, !cmp.state.isEditingName ? jsx(null, null, dashboard && jsx(null, null, jsx("a", {
    sel: '.mp-query-report-header-boards-title-dashboard.disabled-color',
    attrs: {
      href: cmp.helpers.getBackLink()
    },
    on: {
      click: cmp.helpers.handleBoardsDashboardClick
    }
  }, dashboard.title), jsx("span", {
    sel: '.mp-query-report-header-boards-title-caret',
    attrs: {
      icon: "caret-right"
    }
  }, "/")), jsx("div", {
    sel: '.mp-query-report-header-boards-title-bookmark',
    class: {
      'can-edit': canEdit,
      'disabled-color': !canEdit
    },
    on: {
      mouseover: () => cmp.update({
        canEditName: canEdit
      }),
      mouseleave: () => cmp.update({
        canEditName: false
      }),
      click: () => canEdit && cmp.helpers.handleEditReportBoards()
    }
  }, cmp.helpers.getReportName(), jsx(SvgIconEl, {
    sel: '.mp-query-report-header-boards-title-edit-name-icon',
    attrs: {
      icon: "edit"
    },
    class: {
      'edit-name-visible': cmp.state.canEditName
    }
  }))) : jsx(InputEl, {
    attrs: {
      'select-on-focus': true
    },
    props: {
      value: cmp.helpers.getReportName()
    },
    on: {
      blur: cmp.helpers.handleReportNameBlur,
      keydown: cmp.helpers.handleReportNameKeydown
    },
    hook: {
      insert: cmp.helpers.handleInputInsert
    }
  }));
};

const HeaderTitle = cmp => {
  const {
    isDescriptionTruncated
  } = cmp.state;
  const canEdit = cmp.canEditReportName();
  const computedAt = cmp.attr("computed-at");
  const description = cmp.attr("selected-bookmark-description");
  const needsTruncation = description && description.length > 100;
  const samplingNotice = cmp.helpers.getSamplingNotice();
  const isPublicDashboard = cmp.attr("is-public-dashboard") || cmp.state.showPublicBadge;
  return jsx("div", {
    sel: '.mp-query-report-header-title'
  }, jsx("div", {
    sel: '.mp-query-report-header-title-text',
    attrs: {
      elref: "reportTitleButton"
    },
    class: {
      'unsaved-bookmark': !cmp.helpers.hasSelectedEntity(),
      'editable-bookmark': canEdit
    },
    on: {
      click: canEdit && cmp.helpers.editReportClicked
    }
  }, cmp.attr("selected-bookmark-name") || cmp.attr("empty-bookmark-name"), canEdit ? jsx(ButtonEl, {
    attrs: {
      icon: "edit",
      theme: ButtonTheme.Tertiary,
      elref: "reportEditButton"
    },
    on: {
      click: cmp.helpers.editReportClicked
    }
  }) : null), jsx("div", {
    sel: '.mp-query-report-header-title-subtext'
  }, jsx("div", {
    sel: '.mp-query-report-header-title-subtext-description-container'
  }, isPublicDashboard ? getPublicDashboardTextHighlight(cmp.helpers.handleViewPublicDashboardLinksClick) : null, description ? jsx("div", {
    sel: '.mp-query-report-header-description',
    class: {
      'mp-query-report-header-description-truncated': isDescriptionTruncated
    },
    on: {
      click: needsTruncation && cmp.helpers.toggleDescriptionTruncation
    }
  }, jsx("div", {
    sel: '.mp-query-report-header-description-text'
  }, description, !isDescriptionTruncated ? jsx("span", {
    sel: '.mp-query-report-header-description-less'
  }, "less") : null), needsTruncation && isDescriptionTruncated ? jsx("div", {
    sel: '.mp-query-report-header-description-more'
  }, "more") : null) : null), jsx("div", {
    sel: '.mp-query-report-header-metadata'
  }, computedAt ? jsx("div", {
    sel: '.mp-query-report-header-last-updated'
  }, jsx(LastUpdatedEl, {
    attrs: {
      'is-compact': false,
      'last-refresh-date': computedAt,
      'preface-text': "Updated",
      'refresh-interval-ms': cmp.attr("auto-refresh-interval-ms")
    },
    on: {
      refresh: cmp.helpers.handleAutoRefresh
    }
  })) : null, samplingNotice ? jsx("div", {
    sel: '.mp-query-report-header-sampling-notice'
  }, samplingNotice) : null)));
};

const HeaderActions = cmp => {
  var _a, _b;

  const creatorId = cmp.attr("selected-bookmark-user-id");
  const creatorName = cmp.attr("selected-bookmark-user-name");
  const creatorEmail = cmp.attr("selected-bookmark-user-email");
  const saveAction = cmp.helpers.getSaveAction();
  return jsx("div", {
    sel: '.mp-query-report-header-actions'
  }, jsx(ControlBarEl, {
    attrs: cmp.helpers.serializeAttributes(Object.assign({
      theme: "tertiary",
      controls: cmp.helpers.getHeaderActionItems(),
      'overflow-controls': cmp.helpers.getHeaderActionOverflowItems(),
      'overflow-menu-width': 200
    }, cmp.helpers.isDashboardBoardsUiEnabled() || cmp.helpers.isReportBoardsUiEnabled() ? {
      'overflow-menu-height': 400,
      'style-override': ".mp-control-bar .mp-control-bar-control {margin-right: 16px;}"
    } : {})),
    on: {
      select: cmp.helpers.onHeaderActionClick
    }
  }, jsx("div", {
    attrs: {
      slot: "createdBy",
      class: "created-by"
    }
  }, creatorId ? jsx(UserIconEl, {
    sel: '.created-by-icon',
    attrs: {
      id: creatorId,
      name: creatorName,
      email: creatorEmail,
      size: cmp.helpers.IconSizeType.Medium,
      'label-prefix': "Created by",
      'subscribe-to-updates': true
    }
  }) : null), cmp.helpers.showShareButton() ? jsx(SharingStatusButtonEl, {
    attrs: {
      elref: "reportShareButton",
      disabled: !cmp.helpers.isShareButtonEnabled(),
      'hide-share-button': cmp.helpers.isReportBoardsUiEnabled(),
      id: cmp.attr("selected-bookmark-id"),
      'is-select': false,
      'project-id': cmp.attr("project-id"),
      theme: cmp.helpers.getShareButtonTheme(),
      'tooltip-text': !cmp.helpers.isReportBoardsUiEnabled() && cmp.helpers.getShareTooltipText(),
      type: cmp.helpers.getSharableEntityType(),
      slot: "sharing"
    },
    on: {
      share: cmp.helpers.isShareButtonEnabled() ? cmp.helpers.handleSharingStatusButtonClick : null
    }
  }) : null, cmp.helpers.getHeaderActionItemsSlots().map(item => jsx("slot", {
    attrs: {
      name: item.slot,
      slot: item.slot
    }
  }))), cmp.helpers.isDashboardBoardsUiEnabled() && cmp.boardsCanSave() && jsx("div", {
    sel: '.boards-extra-actions'
  }, jsx("div", {
    sel: '.gap-line'
  }), jsx("div", {
    sel: '.boards-header-action'
  }, jsx(ButtonEl, {
    attrs: {
      icon: "",
      elref: saveAction.elref,
      disabled: saveAction.isDisabled,
      theme: ButtonTheme.Tertiary
    },
    on: {
      click: () => cmp.helpers.onHeaderActionClick({
        detail: {
          value: HeaderAction.Save
        }
      })
    }
  }, "Save"), saveAction.tooltip && jsx(TooltipEl, {
    attrs: {
      placement: Placement.Top,
      'body-level': true,
      text: (_a = saveAction.tooltip) === null || _a === void 0 ? void 0 : _a.text
    }
  })), jsx("div", {
    sel: '.boards-header-action'
  }, jsx("slot", {
    attrs: {
      name: "boardsAddReport"
    }
  }))), cmp.helpers.isReportBoardsUiEnabled() && jsx("div", {
    sel: '.boards-extra-actions'
  }, jsx("div", {
    sel: '.gap-line'
  }), !cmp.isBoardsDuplicateButtonHidden() && jsx("div", {
    sel: '.boards-header-action',
    attrs: {
      slot: "boardsDuplicate"
    }
  }, jsx(BoardsSaveButtonEl, {
    attrs: {
      'selected-dashboard-id': null,
      'user-id': cmp.attr("user-id"),
      theme: ButtonTheme.Tertiary,
      disabled: cmp.attr("invalid-entity"),
      elref: "boardsDuplicateButton",
      'align-right': true,
      label: "Duplicate",
      'search-placeholder': "Duplicate to..."
    },
    props: {
      dashboardController: cmp.dashboardController
    },
    on: {
      menuchange: cmp.helpers.handleBoardsDuplicateMenuChange,
      save: ev => cmp.helpers.boardsSaveInDashboard(ev.detail.dashboardId, SaveModes.SaveNew)
    }
  })), cmp.boardsCanSave() && jsx("div", {
    sel: '.boards-header-action'
  }, jsx(BoardsSaveButtonEl, {
    attrs: {
      'selected-dashboard-id': (_b = cmp.getDashboard()) === null || _b === void 0 ? void 0 : _b.id,
      'user-id': cmp.attr("user-id"),
      theme: ButtonTheme.Primary,
      disabled: cmp.isBoardsSaveButtonDisabled(),
      tooltip: cmp.isBoardsSaveButtonDisabled() && cmp.getSaveTooltipText(),
      elref: "boardsSaveButton",
      'align-right': true,
      label: "Save and Close",
      'search-placeholder': "Save to dashboard..."
    },
    props: {
      dashboardController: cmp.dashboardController
    },
    on: {
      menuchange: cmp.helpers.handleBoardsSaveMenuChange,
      save: ev => cmp.helpers.boardsSaveInDashboard(ev.detail.dashboardId)
    }
  }))));
};

export function template() {
  const dashboard = this.getDashboard();
  const isReportBoardsUiEnabled = this.helpers.isReportBoardsUiEnabled();
  return jsx("div", {
    sel: '.mp-query-report-header',
    class: {
      'boards-mode': isReportBoardsUiEnabled
    }
  }, this.helpers.isHeaderReady() ? isReportBoardsUiEnabled ? jsx(null, null, jsx("div", {
    sel: '.mp-query-report-header-top-bar'
  }, jsx(ButtonEl, {
    attrs: {
      icon: "arrow-left",
      href: this.helpers.getBackLink(),
      theme: ButtonTheme.Tertiary
    },
    on: {
      click: this.helpers.handleBoardButtonClick
    }
  }), BoardsTitle(this, dashboard), HeaderActions(this))) : jsx(null, null, HeaderTitle(this), HeaderActions(this)) : null, jsx(AlertModal, {
    cmp: this
  }));
}